import SimpleHomeBreadcrumb from '@Components/Shared/SimpleHomeBreadcrumb';

const PixelsPolicyView = (props) => {
    return (
        <div className='info-content-container'>
            <div className='info-content-header'>
                <SimpleHomeBreadcrumb homeRoute={props.BreadCrumbHomeRoute} displayText={props.BreadCrumbText} />
            </div>
            <div className='legal-container'>
                <span dangerouslySetInnerHTML={{ __html: props.HtmlMarkup }} />
            </div>
        </div>
    );
};

export default PixelsPolicyView;
global.PixelsPolicyView = PixelsPolicyView;